import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { INavigateCollectionTriageClipV2Request } from './navigate-collection-triage-clip-v2-request';
import type { INavigateCollectionTriageClipV2Response } from './navigate-collection-triage-clip-v2-response';
import { navigateCollectionTriageClipV2ResponseSchema } from './navigate-collection-triage-clip-v2-response';

/**
 * @deprecated Superseded by `navigateCollectionTriageClipV3Api`. Frozen, not
 * deleted - an old app binary may still call it. See "Web-only / orphan versions
 * pending deletion" in apps/api/CLAUDE.md.
 */
export async function navigateCollectionTriageClipV2Api({
  collectionId,
  clipId,
  direction,
}: INavigateCollectionTriageClipV2Request): Promise<
  IValidatedResponse<INavigateCollectionTriageClipV2Response>
> {
  return getRequest<INavigateCollectionTriageClipV2Response>({
    path: `/sys/collections/${collectionId}/triage/navigate/v2?clipId=${clipId}&direction=${direction}`,
    schema: navigateCollectionTriageClipV2ResponseSchema,
  });
}
